(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6803],{

/***/ 43962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ brands; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/index.js + 177 modules
var components = __webpack_require__(74030);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/profileSlice.js
var profileSlice = __webpack_require__(82025);
// EXTERNAL MODULE: ./containers/index.js + 35 modules
var containers = __webpack_require__(44420);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var reselect_es = __webpack_require__(68697);
;// CONCATENATED MODULE: ./store/profileSelector.js

var getBrandsSeo = (0,reselect_es/* createSelector */.P1)(function (state) {
  return state.profile;
}, function (profile) {
  return profile.seo;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./pages/brands/index.js












var Brands = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 7237).then(__webpack_require__.bind(__webpack_require__, 67237));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(67237)];
    }
  }
});

var NextBrandsPage = function NextBrandsPage() {
  var brandsSeo = (0,es/* useSelector */.v9)(getBrandsSeo);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(containers/* MetaData */.U4, {
      title: brandsSeo === null || brandsSeo === void 0 ? void 0 : brandsSeo.title,
      description: brandsSeo === null || brandsSeo === void 0 ? void 0 : brandsSeo.description
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Brands, {
      seoData: brandsSeo
    })]
  });
};

NextBrandsPage.getInitialProps = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
    var reduxStore;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            reduxStore = _ref.reduxStore;
            _context.next = 3;
            return reduxStore.dispatch((0,profileSlice/* fetchBrands */.S0)());

          case 3:
            return _context.abrupt("return", {});

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}();

/* harmony default export */ var brands = (NextBrandsPage);

/***/ }),

/***/ 58087:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands",
      function () {
        return __webpack_require__(43962);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(58087); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);